import { render, staticRenderFns } from "./TambahTipePegawai.vue?vue&type=template&id=7112ccab&scoped=true"
import script from "./TambahTipePegawai.vue?vue&type=script&lang=js"
export * from "./TambahTipePegawai.vue?vue&type=script&lang=js"
import style0 from "./TambahTipePegawai.vue?vue&type=style&index=0&id=7112ccab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7112ccab",
  null
  
)

export default component.exports